import { Component, ElementRef, Input, OnInit, inject } from '@angular/core';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-stamp-progress',
  templateUrl: './stamp-progress.component.html',
  styleUrls: ['./stamp-progress.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
@TakeUntilDestroy
export class StampProgressComponent implements OnInit {
  @Input() rescaleWithEm: number = 1;
  @Input() event: LimitedTimeEvent;

  public MAX_STAMPS_PER_LINE = 5;
  public SPLIT_STAMPS = 6;

  freeStampsArray: Array<number> = [];
  objectiveStampsArray: Array<number> = [];

  private readonly elRef = inject(ElementRef);

  ngOnInit(): void {
    this.freeStampsArray = Array.from(Array(Number(this.event.properties.freesteps)).keys());
    this.objectiveStampsArray = Array.from(Array(this.event.total - Number(this.event.properties.freesteps)).keys());

    this.setRescale();
  }

  private setRescale(): void {
    this.elRef.nativeElement.style = `transform: scale(${this.rescaleWithEm})`;
  }
}
